import styled from 'styled-components';

export const TableContent = styled.div`
  flex: 1;
`;
